// AdSlot.jsx — Google AdSense slot wrapper.
// Renders nothing if ADSENSE_CLIENT or the slot ID is not configured.
import { useEffect, useRef } from 'react';
import { ADSENSE_CLIENT, AD_SLOTS } from '../../config/referrals';

/**
 * @param {'leaderboard'|'rectangle'|'inArticle'} slot  Key from AD_SLOTS config.
 * @param {string} className  Extra Tailwind classes for the wrapper div.
 */
export default function AdSlot({ slot = 'rectangle', className = '' }) {
  const ref = useRef(null);
  const slotId = AD_SLOTS[slot];

  useEffect(() => {
    if (!ADSENSE_CLIENT || !slotId) return;
    try {
      // Push the ad unit after mount — AdSense fills it asynchronously.
      (window.adsbygoogle = window.adsbygoogle || []).push({});
    } catch (_) {}
  }, [slotId]);

  // Don't render anything until the publisher ID and slot ID are configured.
  if (!ADSENSE_CLIENT || !slotId) return null;

  const formats = {
    leaderboard: { style: { display: 'block', width: '100%', height: '90px' }, format: 'horizontal' },
    rectangle:   { style: { display: 'block', width: '100%', height: '250px' }, format: 'rectangle' },
    inArticle:   { style: { display: 'block', width: '100%' }, format: 'fluid', layout: 'in-article' },
  };
  const { style, format, layout } = formats[slot] || formats.rectangle;

  return (
    <div className={`overflow-hidden text-center ${className}`}>
      <ins
        ref={ref}
        className="adsbygoogle"
        style={style}
        data-ad-client={ADSENSE_CLIENT}
        data-ad-slot={slotId}
        data-ad-format={format}
        {...(layout ? { 'data-ad-layout': layout } : {})}
        data-full-width-responsive="true"
      />
    </div>
  );
}
